import translate from '../../../core/tools/translate';

const reducers = {
    brownfield (res) {
        const doc = {};
        doc.address = {
            endereco: res.logradouro,
            bairro: res.neighborhood,
            cidade: res.county,
            uf: res.federativeUnit,
            regiao: res.region,
            cep: res.cep,
            pma: res.pmaName
        };

        doc.information = {
            nome: res.pointName,
            tipo: res.currentPointType ? `${res.currentPointType.name} — ${res.currentPointType.description}` : '',
            tipoRecomendado: res.futurePointType ? `${res.futurePointType.name} — ${res.futurePointType.description}` : '',
            acao: res.action ? res.action.name : '',
            ano: res.yearReference,
            gdsi: res.actionStatus ? translate(`Brownfield.Gdsi.${String(res.actionStatus.description).toUnderscoreCase()}`) : ''
        };

        doc.location = {
            latitude: res.latitude,
            longitude: res.longitude
        };

        return doc;
    }
};

export default reducers;



// WEBPACK FOOTER //
// ./src/scripts/api/endpoints/brownfield/reducers.js